import { MutableRefObject, useEffect, useState } from 'react'

interface ScrollAreas {
  hasOverflow: boolean
  isMaxScroll: boolean
  position: number
}

interface ScrollInfoProps {
  x: ScrollAreas
  y: ScrollAreas
}

const useScrollInfo = (
  elementRef: MutableRefObject<HTMLDivElement>
): ScrollInfoProps => {
  const [scrollInfo, setScrollInfo] = useState<ScrollInfoProps>({
    x: {
      hasOverflow: true,
      isMaxScroll: false,
      position: 0,
    },
    y: {
      hasOverflow: true,
      isMaxScroll: false,
      position: 0,
    },
  })

  const getScrollInfo = (event) => {
    let timer = null

    if (timer !== null) {
      clearTimeout(timer)
    }

    timer = setTimeout(function () {
      const target = event.target

      const scrollInfo = {
        x: {
          position: target.scrollLeft,
          hasOverflow: target.scrollWidth > target.offsetWidth,
          isMaxScroll:
            Math.abs(
              target.scrollWidth - target.clientWidth - target.scrollLeft
            ) < 1,
        },
        y: {
          position: target.scrollTop,
          hasOverflow: target.scrollHeight > target.offsetHeight,
          isMaxScroll:
            Math.abs(
              target.scrollHeight - target.clientHeight - target.scrollTop
            ) < 1,
        },
      }

      setScrollInfo(scrollInfo)
    }, 150)
  }

  useEffect(() => {
    const element = elementRef.current

    if (element) {
      element.addEventListener('scroll', getScrollInfo, { passive: true })

      return () => {
        element.removeEventListener('scroll', getScrollInfo)
      }
    }
  }, [elementRef])

  return scrollInfo
}

export default useScrollInfo
